define.alias("shared/components/shared/trial-countdown", "media/components/shared/trial-countdown");